import { Link } from 'react-router-dom';
import { HomeOutlined, DiffOutlined, EditOutlined, ProjectOutlined, UserAddOutlined, ToolOutlined, MailOutlined, BugOutlined, GiftOutlined, ThunderboltOutlined } from '@ant-design/icons';

function getItem(label, key, icon, children, type) {
  return {
    label,
    key,
    icon,
    children,
    type
  }
}

const items = [
  getItem(<Link to='/layout/home'>home</Link>, '/layout/home', <HomeOutlined/>),
  getItem(<Link to='/layout/order'>Order</Link>, '/layout/order', <ProjectOutlined />),
  getItem(<Link to='/layout/quote'>Quote</Link>, '/layout/quote', <DiffOutlined/>),
  getItem(<Link to='/layout/email'>Email</Link>, '/layout/email', <MailOutlined/>),
  getItem(<Link to='/layout/error-log'>Log</Link>, '/layout/error-log', <BugOutlined/>),
  getItem(<Link to='/layout/setting'>Setting</Link>, '/layout/setting', <EditOutlined/>),
  getItem(<Link to='/layout/referral-code'>Code</Link>, '/layout/referral-code', <GiftOutlined/>),
  getItem(<Link to='/layout/manual-webhook'>Manual</Link>, '/layout/manual-webhook', <ThunderboltOutlined/>),
]

const generateItems =  (userInfo) => {
  if (parseInt(userInfo.role, 10) === 0) {
    return [
      ...items,
      getItem(<Link to='/layout/account'>Account</Link>, '/layout/account', <UserAddOutlined />),
      getItem(<Link to='/layout/manage'>manage</Link>, '/layout/manage', <ToolOutlined />)
    ]
  }
  
  return items
}



export default generateItems;